import { Property } from "@/features/survey/types";
import {
  getIconColor,
  getMenuMarkerContent,
} from "@/shared/components/MenuBar/utils/menuHelpers";
import { EmeraldIcon } from "@emerald-react/icon";

interface PropertyMarkerProps {
  property: Property;
  properties?: Property[];
  size?: "sm" | "md";
  textColor?: string;
}

const PropertyMarker = ({
  property,
  properties = [],
  size = "md",
  textColor = "text-white",
}: PropertyMarkerProps) => {
  const iconColor = getIconColor(property);
  const markerContent = getMenuMarkerContent(property, properties);
  const sizeClass = size === "sm" ? "w-5 h-5" : "w-6 h-6";

  return (
    <div
      className={`shrink-0 ${sizeClass} rounded-full flex items-center justify-center text-xs ${textColor}`}
      style={{
        ...(property.isCurrentLocation
          ? { backgroundColor: "white", color: iconColor }
          : { backgroundColor: iconColor }),
        border: "2px solid white",
      }}
    >
      {property.isCurrentLocation ? (
        <EmeraldIcon icon="stars" type="filled" variant="icon" />
      ) : (
        markerContent
      )}
    </div>
  );
};

export default PropertyMarker;
